module.exports = __webpack_public_path__ + "img/qrcode.6249ceef.png";